import { Box } from '@zillow/constellation-10';
import Bone from '../../../Bone';
import { Col } from '@zg-rentals/zrs-comet';

export default function InboxPanelHeaderSkeleton(): JSX.Element {
  return (
    <Box
      css={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: 'default',
        paddingInline: 'tight',
      }}
    >
      <Col xs={6}>
        <Box css={{ paddingTop: 'loose' }}>
          <Bone type="line" dark={true} />
        </Box>
      </Col>

      <Col xs={8}>
        <br />
        <Bone dark={true} type="line" />
        <br />
      </Col>

      <Col xs={6}>
        <Bone dark={true} type="line" />
        <br />
      </Col>
    </Box>
  );
}
